export enum ETutorial {
  SEEN_WHATS_NEW = 'whats-new',
  SEEN_INSTORE_ONLINE_REWARD = 'in-store-online-reward-whats-new',
  SHOW_PLATFORM_FEEDBACK = 'platform-feedback',
  SEEN_INACTIVE_CONSUMER_HOVER = 'inactive-consumer-hover',
  SEEN_COIN_NETWORK_GUIDED_TOUR = 'coin-network-guided-tour'
}
